'use strict';

angular.module('amexReconciliationApp')
  .service('SessionResetService', function (SessionTimeoutService) {

    this.response = function (originalResponse) {
      if (isNotAngularTemplate(originalResponse)) {
        SessionTimeoutService.resetRemainingTime();
      }

      return originalResponse;
    };

    function isNotAngularTemplate(response) {
      return typeof response.data !== 'string';
    }

  });

angular.module('amexReconciliationApp')
  .config(function ($httpProvider) {
    $httpProvider.interceptors.push('SessionResetService');
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/services/SessionResetService.js
// module id = 646
// module chunks = 0